<template>
  <HelloWorld />
<!--    <div style="height: 1000px"></div>-->
<!--    <div class="box">-->

<!--    </div>-->

</template>

<script>
// import gsap from "gsap";
// import scrollTrigger from "gsap/ScrollTrigger"
import HelloWorld from './view/menu.vue'
export default {
    name: 'App',
    components: {
        HelloWorld
    },
    data() {
        return {

        }
    },
    methods: {
    },
    mounted() {
        // gsap.registerPlugin(scrollTrigger)
        // gsap.set(".box", { opacity: 0 });
        //
        //
        // gsap.to(".box", {
        //     opacity: 1,
        //     scrollTrigger: {
        //         trigger: ".box",
        //         start: "top center",
        //         end: "bottom center",
        //         markers: true
        //     }
        // })

        // router.addRoute({ name: "解决方案", path: "/cvi/solution", component: cardVue });
        // router.addRoute({ name: "产品中心", path: "/cvi/product", component: cardVue });
        // router.addRoute({ name: "成功案例", path: "/cvi/case", component: cardVue });
        // router.addRoute({ name: "企业动态", path: "/cvi/companynew", component: cardVue });
        // router.addRoute({ name: "关于中协", path: "/cvi/aboutus", component: cardVue });
    }
}
</script>

<style lang="less">
    .box {
        margin-left: 100px;
        width: 100px;
        height: 100px;
        border-radius: 20px;
        background: dodgerblue;
    }
    .el-image__inner, video {
        object-fit: cover;
    }
    .el-loading-mask {
        &.custom-loading {
            .path {
                stroke: #FF6900;
            }
            .el-loading-text {
                color: #FF6900;
                font-size: 16px;
            }
        }
    }
    * {
        padding: 0;
        margin: 0;
        list-style: none;
        user-select: none;
    }
    body {
        overflow-x: hidden;
        overflow-y: auto;
        &::-webkit-scrollbar{
            width: 0;
            border-radius: 10px;
        }
        //&::-webkit-scrollbar-thumb {
        //    background: #FF6900;
        //    border-radius: 10px;
        //}
    }
    .el-popper.menu-popper {
        border: none !important;
        border-top: 1px solid #dfdfdf !important;
        inset: 64px auto auto 0 !important;
        border-radius: 0 !important;
        height: auto !important;
        .el-menu--popup {
            background-color: #FFFFFF !important;
            padding: 0 0 20px 0 !important;
            box-shadow: none;
            width: 100vw;
            .menu-item__content {
                margin: 0 auto;
                max-width: 1200px;
                display: flex;
                justify-content: center;
                .no-padding {
                    padding: 0 !important;
                }
                &.grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                }
                &.flex {
                    flex-wrap: wrap;
                    .child-view {
                        padding: 0 30px;
                    }
                }
                .el-menu-item {
                    height: auto;
                    line-height: 1;
                }
            }
        }
    }
    .el-image{
        overflow: hidden !important;
    }
    .el-pagination {
        width: 100%;
        display: flex;
        justify-content: center;
        button {
            .el-icon {
                font-size: 18px !important;
            }
            &:hover {
                background-color: #ff6600 !important;
                color: #FFFFFF !important;
            }
        }
        .el-pager {
            .number {
                font-size: 14px !important;
                &.is-active {
                    background-color: #ff6600 !important;
                }
                &:hover {
                    background-color: #ff6600 !important;
                    color: #FFFFFF !important;
                }
            }
            .more {
                font-size: 14px !important;
                &:hover {
                    color: #ff6600 !important;
                }
            }
        }
    }
</style>
